import React from 'react';
import { Helmet } from 'react-helmet-async';
import PageHeader from '../components/PageHeader';

function ComplianceCenter() {
	return (
		<>
			<Helmet>
				<title>Compliance Center • Appex Connect Hub</title>
				<meta name="description" content="Our compliance framework: consent capture, STOP/HELP support, audit logs, data privacy, and opt-out controls." />
			</Helmet>
			<PageHeader
				title="Compliance Center"
				subtitle="A2P/TCPA alignment with auditable consent, STOP/HELP support, and data minimization."
			/>
			<section className="section">
				<div className="container">
				<div className="grid">
					<div className="card" style={{ padding: 18 }}>
						<div className="icon-circle">
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 11h10M7 7h10M7 15h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M5 4h14v16H5V4Z" stroke="currentColor" strokeWidth="1.5"/></svg>
						</div>
						<h3>Consent & Disclosures</h3>
						<p className="helper">
							We require explicit SMS consent and TCPA acknowledgments. Disclosures state message frequency,
							rates, STOP/HELP keywords, and that consent isn’t required to obtain credit.
						</p>
					</div>
					<div className="card" style={{ padding: 18 }}>
						<div className="icon-circle">
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 8h12v8H6V8Z" stroke="currentColor" strokeWidth="1.5"/><path d="M10 12h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M8 4h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
						</div>
						<h3>Opt-Out & Keywords</h3>
						<p className="helper">
							STOP removes consent; HELP delivers assistance info. We maintain an internal opt-out list in addition
							to carrier-level blocking.
						</p>
					</div>
					<div className="card" style={{ padding: 18 }}>
						<div className="icon-circle">
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 5h12v14H6V5Z" stroke="currentColor" strokeWidth="1.5"/><path d="M9 9h6m-6 3h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M10 5V3m4 2V3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
						</div>
						<h3>Audit Records</h3>
						<p className="helper">
							Consent events store timestamp, method, user agent, and referral URL. Data is retained to evidence consent.
						</p>
					</div>
					<div className="card" style={{ padding: 18 }}>
						<div className="icon-circle">
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 9h14v8H5V9Z" stroke="currentColor" strokeWidth="1.5"/><path d="M9 9V7a3 3 0 0 1 6 0v2" stroke="currentColor" strokeWidth="1.5"/></svg>
						</div>
						<h3>Data Privacy</h3>
						<p className="helper">
							We share data only with providers needed to fulfill a request. No sale of personal data. Additional rights
							may apply by jurisdiction.
						</p>
					</div>
					<div className="card" style={{ padding: 18 }}>
						<div className="icon-circle">
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 6h10v12H7V6Z" stroke="currentColor" strokeWidth="1.5"/><path d="M9.5 9.5h5v5h-5v-5Z" stroke="currentColor" strokeWidth="1.5"/></svg>
						</div>
						<h3>Content Controls</h3>
						<p className="helper">
							Campaign templates are reviewed to avoid prohibited content and to ensure clear brand identification, reply prompts, and contact details.
						</p>
					</div>
					<div className="card" style={{ padding: 18 }}>
						<div className="icon-circle">
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 6h12v7H6V6Z" stroke="currentColor" strokeWidth="1.5"/><path d="M8 13h8l2 5H6l2-5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
						</div>
						<h3>Deliverability</h3>
						<p className="helper">
							A2P-friendly sending patterns, frequency caps, and complaint monitoring keep sender reputation healthy and reduce carrier filtering.
						</p>
					</div>
					<div className="card" style={{ padding: 18 }}>
						<div className="icon-circle">
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 9h12v8H6V9Z" stroke="currentColor" strokeWidth="1.5"/><path d="M9 12h6M9 15h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
						</div>
						<h3>Messaging Practices</h3>
						<ul className="helper" style={{ margin: 0, paddingLeft: 18 }}>
							<li>Message frequency varies; STOP to opt out, HELP for help.</li>
							<li>No sale or rental of mobile numbers for marketing.</li>
							<li>Internal opt-outs honored immediately; carrier blocks respected.</li>
							<li>Not a lender; communications are project/service-related.</li>
						</ul>
					</div>
				</div>
				</div>
			</section>
		</>
	);
}

export default ComplianceCenter;


